import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { useEffect } from "react";
import moment from "moment";
import { numeral, Typography, setLocale } from "../../../";
import _ from "lodash"; // const COLORS = ["#33ff99", "#00cdd6", "#0093ff", "#0400b5"];

var COLORS = {
  campus: "#33ff99",
  events: "#00cdd6",
  academies: "#0093ff",
  others: "#0400b5",
  marketing: "#33ff99",
  recurring: "#33aa99",
  office: "#336099",
  initial: "#333199",
  marketplace: "#003199"
};

var CustomizedTick = function CustomizedTick(_ref) {
  var payload = _ref.payload,
      x = _ref.x,
      y = _ref.y,
      props = _objectWithoutProperties(_ref, ["payload", "x", "y"]);

  return /*#__PURE__*/React.createElement("text", {
    x: x,
    y: y,
    fill: "#fff",
    textAnchor: "middle",
    dominantBaseline: "middle",
    "font-family": "Montserrat",
    "font-size": "12px"
  }, "".concat(moment(payload.value, "YYYYMM").format("MMMM")));
};

var CustomizedMonthTick = function CustomizedMonthTick(_ref2) {
  var payload = _ref2.payload,
      x = _ref2.x,
      y = _ref2.y,
      props = _objectWithoutProperties(_ref2, ["payload", "x", "y"]);

  return /*#__PURE__*/React.createElement("text", {
    x: x,
    y: y,
    fill: "#fff",
    textAnchor: "middle",
    dominantBaseline: "middle",
    "font-family": "Montserrat",
    "font-size": "12px"
  }, "".concat(moment(payload.value, "MM").format("MMMM")));
};

var CustomizedLabel = function CustomizedLabel(props) {
  // console.log("CustomizedLabel", props);
  var x = props.x,
      y = props.y,
      width = props.width,
      height = props.height,
      value = props.value,
      translation = props.translation,
      locale = props.locale;
  /*  useEffect(() => {
    setLocale(locale);
  }, [locale]); */

  var radius = 10;
  return value > 0 ? /*#__PURE__*/React.createElement("text", {
    x: x + width / 2,
    y: y - radius,
    fill: "#fff",
    textAnchor: "middle",
    dominantBaseline: "middle",
    "font-family": "Montserrat"
  }, "".concat(numeral(value).format("0,0[.]00 $"))) : null;
};

var CustomizedKLabel = function CustomizedKLabel(props) {
  // console.log("CustomizedLabel", props);
  var x = props.x,
      y = props.y,
      width = props.width,
      height = props.height,
      value = props.value,
      translation = props.translation,
      locale = props.locale,
      year = props.year;
  /*  useEffect(() => {
    setLocale(locale);
  }, [locale]); */

  var radius = 10;
  return value > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("text", {
    x: x + width / 2,
    y: y - radius * 3,
    fill: "#fff",
    textAnchor: "middle",
    dominantBaseline: "middle",
    "font-family": "Montserrat"
  }, year), /*#__PURE__*/React.createElement("text", {
    x: x + width / 2,
    y: y - radius,
    fill: "#fff",
    textAnchor: "middle",
    dominantBaseline: "middle",
    "font-family": "Montserrat"
  }, "".concat(numeral(value).format("0 a")))) : null;
};

var CustomizedLegend = function CustomizedLegend(props) {
  // console.log("CustomizedLegend", props);
  var payload = props.payload,
      translation = props.translation;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      "justify-content": "space-evenly",
      "margin-bottom": "40px"
    }
  }, payload.map(function (entry, index) {
    return [/*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        "align-items": "center"
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        background: entry.color,
        width: "14px",
        height: "14px",
        marginRight: "15px"
      }
    }), /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      key: "item-".concat(index)
    }, translation ? translation[entry.value] : entry.value.toUpperCase()))];
  }));
};

var CustomizedYearLegend = function CustomizedYearLegend(props) {
  // console.log("CustomizedLegend", props);
  var payload = props.payload,
      translation = props.translation;

  var payloadSet = _.uniqBy(payload.map(function (item) {
    return _objectSpread(_objectSpread({}, item), {}, {
      value: item.value.split("_")[1]
    });
  }), function (element) {
    return element.value;
  });

  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      "justify-content": "space-evenly",
      "margin-bottom": "40px"
    }
  }, payloadSet.map(function (entry, index) {
    return [/*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        "align-items": "center"
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        background: entry.color,
        width: "14px",
        height: "14px",
        marginRight: "15px"
      }
    }), /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      key: "item-".concat(index)
    }, translation ? translation[entry.value] : entry.value.toUpperCase()))];
  }));
};

var CustomizedTooltip = function CustomizedTooltip(_ref3) {
  var active = _ref3.active,
      payload = _ref3.payload,
      translation = _ref3.translation,
      locale = _ref3.locale;

  // console.log("CustomizedTooltip locale", locale);

  /*  useEffect(() => {
    console.log("CustomizedTooltip useEffect", locale);
     locale ? setLocale(locale) : setLocale("ES");
  }, [locale]); */
  // console.log("CustomizedTooltip translation", translation);
  if (active && payload && payload.length) {
    return /*#__PURE__*/React.createElement("div", {
      style: {
        background: "#424242",
        width: "100%",
        padding: "5px"
      }
    }, Object.keys(payload[0].payload).map(function (entry, index) {
      return entry !== "key" && /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex"
        }
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "body2",
        style: {
          color: COLORS[entry]
        },
        key: "item-".concat(index)
      }, translation ? translation[entry] : entry.toUpperCase()), /*#__PURE__*/React.createElement(Typography, {
        variant: "body2",
        key: "value-".concat(index)
      }, " : ".concat(numeral(payload[0].payload[entry]).format("0,0[.]00 $"))));
    }));
  }

  return null;
};

export { CustomizedTick, COLORS, CustomizedLabel, CustomizedKLabel, CustomizedLegend, CustomizedTooltip, CustomizedMonthTick, CustomizedYearLegend };